<div [ngClass]="inputStyle">
    <label
        *ngIf="label"
        for="{{ inputId }}"
        >{{ label }}</label
    >
    <span [ngClass]="iconSideClass()">
        <i
            *ngIf="icon !== undefined"
            [ngClass]="icon"></i>
        <input
            [attr.sera-read-only]="readOnly ? '' : null"
            id="{{ inputId }}"
            [style]="style"
            type="{{ typeOfInput }}"
            pInputText
            [readOnly]="!manuallyEditable || readOnly"
            [placeholder]="placeholder"
            [required]="required"
            [disabled]="isDisabled"
            [name]="name"
            [(ngModel)]="value"
            [ngClass]="inputClass"
            [class.p-sera-inputText-auto-width]="autoWidth"
            (change)="inputChanged.emit(value)"
            (blur)="inputBlur.emit(value)" />
    </span>
</div>
